import React, { Component } from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'

export default class Brand extends Component {
    constructor(props){
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        
        return (
            <div className="row" id="body">
                    
            <div className="col-12 mx-0 col-lg-10" id="content">

                <div className="row pt-4" id="ui_design">
                    <div className="col-12">
                      <img id="info0" width="100%" src={require('../../../Images/Daily_project/Brand/Brand1.png')} alt="Case_studies_1" />
                    </div>
                </div>
            </div>
                    
            <div className="col-lg-2 d-none d-lg-block px-4 pt-4 h-25 sticky-top" id="sidebar" style={{top: "56px"}}>

                <p className="h4">Project</p>
                <p>
                  <AnchorLink href="#info0" className="bullet">Logo</AnchorLink>
                  <h6 className="text-danger">Not finished</h6>
                </p>

                <div className="row pt-4 px-3">
                <p className="h4">TOOLS</p>

                <div className="col-12 px-2">
                  <div className="row">
                          <img width="25%" className="tools" src={require('../../../Images/Tools/ai.png')} alt="Case_studies_1" />
                  </div>
                </div>
                
              </div>

            </div>
                  
            </div>
    )
}
}